export const adminOrganization = (params: { organization: number }) => `organization:${params.organization}`;
export const adminAllCCEvents = (params: { market_slug: string; cc_status: string }) =>
  `adminAllCCEvents:${params.market_slug}:${params.cc_status}`;
export const adminOrganizationAdmin = (params: { organization: number; userId: number }) =>
  `organization:${params.organization}:user:${params.userId}`;
